/*!

=========================================================
* Argon Design System React - v1.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import { Button, Container, Row, Col, UncontrolledTooltip } from "reactstrap";
import linkedinIcon from "assets/img/icons/common/linkedin-svgrepo-com.svg";

const SECTIONS = [
  {
    heading: "Services",
    links: [
      { label: "Data Consulting", to: "/consulting" },
      { label: "IoT Platform", to: "/platform" },
    ],
  },
  {
    heading: "Platform",
    links: [
      { label: "Industrial Monitoring", to: "/industrial" },
      { label: "Home Connectivity", to: "/home" },
      { label: "Platform Analytics", to: "/data-analytics" },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
    ],
  },
];

class SimpleFooter extends React.Component {
  render() {
    return (
      <>
        <footer className="footer chisp-footer">
          <Container>
            <Row>
              <Col lg="4" className="mb-5 mb-lg-0">
                <Link to="/">
                  <img
                    alt="Chisp"
                    src={require("assets/img/brand/chisp.png")}
                    style={{ height: "40px", width: "auto" }}
                  />
                </Link>
                <p className="mt-3 mb-4" style={{ maxWidth: "320px" }}>
                  Cloud data consulting and IoT monitoring, from one engineering
                  team. We build the data systems your operation runs on.
                </p>
                <Button
                  className="btn-icon-only rounded-circle"
                  style={{ background: "#0077B5", border: "none", color: "#fff" }}
                  href="https://www.linkedin.com/company/chisp/"
                  id="tooltipChispLinkedIn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span
                    className="btn-inner--icon"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <img
                      src={linkedinIcon}
                      alt="LinkedIn"
                      style={{
                        width: "45%",
                        height: "45%",
                        objectFit: "contain",
                        display: "block",
                        filter: "invert(1) brightness(2)",
                        margin: "auto",
                      }}
                    />
                  </span>
                </Button>
                <UncontrolledTooltip delay={0} target="tooltipChispLinkedIn">
                  Follow Chisp Technologies
                </UncontrolledTooltip>
              </Col>

              {SECTIONS.map((section) => (
                <Col lg="2" md="4" xs="6" className="mb-4 mb-lg-0" key={section.heading}>
                  <h6 className="chisp-footer-heading">{section.heading}</h6>
                  {section.links.map((link) => (
                    <Link
                      className="chisp-footer-link"
                      key={link.to}
                      to={link.to}
                    >
                      {link.label}
                    </Link>
                  ))}
                </Col>
              ))}

              <Col lg="2" md="4" xs="6" className="mb-4 mb-lg-0">
                <h6 className="chisp-footer-heading">Get in touch</h6>
                <Link className="chisp-footer-link" to="/contact">
                  Send us a message
                </Link>
              </Col>
            </Row>

            <hr className="my-4" />

            <Row className="align-items-center">
              <Col md="6" className="text-center text-md-left">
                <div className="chisp-footer-legal">
                  &copy; {new Date().getFullYear()} Chisp Technologies LLC
                </div>
              </Col>
              <Col md="6" className="text-center text-md-right">
                <div className="chisp-footer-legal">
                  One Platform. Infinite Insight.
                </div>
              </Col>
            </Row>
          </Container>
        </footer>
      </>
    );
  }
}

export default SimpleFooter;
